import { I18n } from '@aws-amplify/core';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { Branding } from '../../branding';
import { setTOS } from "../../redux/actions";



const useStyles = makeStyles((theme) => ({
    grid: {
        justifyContent: 'center',
        direction: "row"
    },
    typoToS: {
        paddingTop: theme.spacing(3),

    },
    linkTos: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.secondary,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    link: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.link,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    midBul: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        color: Branding.secondary,
    }
}));

const mapStateToProps = (state) => {
    return {
        lang: state.app.lang,
        user: state.app.user,
        tos: state.app.tos
    }
}

const Footer = (props) => {
    const classes = useStyles();
    const copyrightsYear = (new Date()).getFullYear();
    return (
        <Grid container style={{ justifyContent: 'center' }} className={classes.grid}>
            <div style={{ justifyContent: 'center', textAlign: "center" }}>
                <Typography className={classes.typoToS}>
                    <Link
                        href="https://www.youscience.com/about-us/"
                        target="_blank"
                        underline="none"
                        className={classes.linkTos}
                    >
                        {I18n.get("ABOUT_TITLE")}
                    </Link>

                    <span className={classes.midBul}>&bull;</span>

                    <Link
                        href="https://www.youscience.com/privacy-policy/"
                        target="_blank"
                        underline="none"
                        className={classes.linkTos}
                    >
                        {I18n.get("PRIVACY_POLICY_TITLE")}
                    </Link>

                    <span className={classes.midBul}>&bull;</span>


                    <Link
                        href={props?.tos?.url || "https://www.youscience.com/terms-of-service/"}
                        target="_blank"
                        underline="none"
                        className={classes.linkTos}
                    >
                        {I18n.get("TERMS_OF_SERVICE_CONTENT_TITLE")}
                    </Link>

                </Typography>

                <Typography color="secondary" style={{ marginTop: "1em", fontSize: "11px", marginBottom: "2em" }}>
                    Copyright {copyrightsYear} by YouScience. All Rights Reserved.
                </Typography>
            </div>
        </Grid>
    );
}

export default connect(mapStateToProps, { setTOS })(Footer);